import React from 'react';
export function Sectors() {
  const sectors = ['Firmas Legales', 'Logística', 'Comercio Exterior', 'Consultoría', 'Servicios Profesionales'];
  return <section id="sectores" className="bg-arena border-y border-carbon/10 scroll-mt-[120px] md:scroll-mt-[140px] mt-[48px] md:mt-[72px]" data-id="element-368">
      {/* Desktop View */}
      <div className="hidden md:flex max-w-[1200px] mx-auto px-[80px] py-[48px] items-center justify-between" data-id="element-369">
        <span className="font-body text-[13px] text-carbon/45" data-id="element-370">
          Trabajamos con empresas de:
        </span>

        <div className="w-px h-8 bg-carbon/10 mx-6" data-id="element-371"></div>

        <div className="flex items-center gap-[40px]" data-id="element-372">
          {sectors.map((sector, idx) => <span key={idx} className="font-body text-[13px] font-medium text-carbon/55 hover:opacity-100 transition-opacity duration-150 cursor-default" data-id="element-373">
              {sector}
            </span>)}
        </div>

        <div className="w-px h-8 bg-carbon/10 mx-6" data-id="element-374"></div>

        <span className="font-body text-[12px] uppercase text-salvia tracking-[0.1em]" data-id="element-375">
          Colombia y Latinoamérica
        </span>
      </div>

      {/* Mobile View */}
      <div className="md:hidden px-[24px] py-[32px]" data-id="element-376">
        <div className="grid grid-cols-2 gap-[16px]" data-id="element-377">
          {sectors.map((sector, idx) => <span key={idx} className="font-body text-[12px] font-medium text-carbon/55" data-id="element-378">
              {sector}
            </span>)}
          <span className="font-body text-[12px] font-medium text-salvia uppercase tracking-[0.1em] col-span-2 mt-2" data-id="element-379">
            Colombia y Latam
          </span>
        </div>
      </div>
    </section>;
}